export enum GroupTypeEnum {
  STRUKTURALNA = 'STRUKTURALNA',
  PERSONALNA = 'PERSONALNA',
}

export enum GroupPermissionsHistoryActionDescriptionEnum {
  DODANO = 'group.history.action.added',
  ZEDYTOWANO = 'group.history.action.edited',
  USUNIETO = 'group.history.action.deleted',
}
